import Rest from '../rest'

/******************************************************************************
 *  Listy city
 *****************************************************************************/

/**
 * @type {Address}
 */
export default class Address extends Rest {

    constructor() {
        super('https://servicodados.ibge.gov.br/api/v1/localidades')
    }

    states(){
        return this.http.get(
            this.resource + '/estados/',
            {

            }
        )
    }

}